export default __webpack_public_path__ + "static/emma-1023f8a028373e5a5da1b197ace2cbb6.png";